<template>
  <PublicLayout>
    <div class="catalog-public__container">
      <!-- Возврат к каталогу — через таб «Техника из каталога», кнопка «Назад» не нужна -->
      <div class="row justify-content-center mt-4 mb-4">
        <div class="col-md-8 col-lg-6">
          <div class="application-heading">
            <h3>Заявка на лизинг</h3>
            <div class="alert alert-info mb-0 text-start">Заполните форму, и наш менеджер свяжется с вами в течение 15 минут</div>
            <div size="2" class="mb-4 hr"></div>
          </div>

          <ui-input-box-floating :error="errors.PLName">
            <ui-input v-model="PLName" class="form-control" placeholder="Наименование предмета лизинга" />
            <ui-input-label>Наименование предмета лизинга</ui-input-label>
          </ui-input-box-floating>

          <ui-input-box-floating class="mt-3" :error="errors.PLBrand">
            <ui-input v-model="PLBrand" class="form-control" placeholder="Марка" />
            <ui-input-label>Марка</ui-input-label>
          </ui-input-box-floating>

          <ui-input-box-floating class="mt-3" :error="errors.PLModel">
            <ui-input v-model="PLModel" class="form-control" placeholder="Модель" />
            <ui-input-label>Модель</ui-input-label>
          </ui-input-box-floating>

          <div class="row">
            <div class="col-6">
              <ui-input-box-floating class="mt-3" :error="errors.PLDate">
                <ui-input type="number" v-model="PLDate" class="form-control" placeholder="Год выпуска" />
                <ui-input-label>Год выпуска</ui-input-label>
              </ui-input-box-floating>
            </div>
            <div class="col-6">
              <ui-input-box-floating class="mt-3" :error="errors.PLQty">
                <ui-input type="number" v-model="PLQty" class="form-control" placeholder="Количество" />
                <ui-input-label>Количество</ui-input-label>
              </ui-input-box-floating>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <ui-input-box-floating class="mt-3" :error="errors.currency">
                <select v-model="currency" class="form-control form-select">
                  <option>Рубль</option>
                  <option>Юань</option>
                  <option>Доллар</option>
                  <option>Евро</option>
                </select>
                <ui-input-label>Валюта</ui-input-label>
              </ui-input-box-floating>
            </div>
            <div class="col-6">
              <ui-input-box-floating class="mt-3" :error="errors.PLPrice">
                <ui-input type="number" v-model="PLPrice" class="form-control" placeholder="Стоимость" />
                <ui-input-label>Стоимость</ui-input-label>
              </ui-input-box-floating>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <ui-input-box-floating class="mt-3" :error="errors.name">
                <ui-input v-model="name" class="form-control" placeholder="Имя" />
                <ui-input-label>Имя</ui-input-label>
              </ui-input-box-floating>
            </div>
            <div class="col-6">
              <ui-input-box-floating class="mt-3" :error="errors.phone">
                <ui-input v-maska data-maska="+7 (###) ###-##-##" v-model="phone" class="form-control"
                  placeholder="Телефон" />
                <ui-input-label>Телефон</ui-input-label>
              </ui-input-box-floating>
            </div>
          </div>

          <ui-input-box-floating class="mt-3" :error="errors.email">
            <ui-input v-model="email" class="form-control" placeholder="E-mail" />
            <ui-input-label>E-mail</ui-input-label>
          </ui-input-box-floating>

          <div v-if="error" class="login-alert p-3 text-center mt-3">
            <div class="text-primary">Внимание!</div>
            <span>{{ error }}</span>
          </div>

          <div v-if="success" class="success-alert p-3 text-center mt-3">
            <div class="text-primary">Внимание!</div>
            <span>{{ success }}</span>
          </div>

          <ui-button @click="send" class="btn-base mt-3 me-2" :loading="loadingSend"
            :disabled="loadingSend">Отправить</ui-button>
        </div>
      </div>
    </div>
  </PublicLayout>
</template>

<script>
import { postApi } from "@/run";

import PublicLayout from "./PublicLayout.vue";

export default {
  name: "catalog-public-application",
  components: { PublicLayout },
  data() {
    return {
      loadingSend: false,
      currency: "Рубль",
      phone: "+7",
      PLName: null,
      PLBrand: null,
      PLModel: null,
      PLDate: null,
      PLQty: null,
      PLPrice: null,
      name: null,
      email: null,
      error: null,
      errors: [],
      success: null,
    };
  },
  created() {
    document.title = "Заявка на лизинг - STONE-XXI";
  },
  methods: {
    send() {
      this.loadingSend = true;
      this.error = null;
      this.success = null;

      postApi("/requestPublic", {
        PLName: this.PLName,
        PLBrand: this.PLBrand,
        PLModel: this.PLModel,
        PLDate: this.PLDate,
        PLQty: this.PLQty,
        currency: this.currency,
        PLPrice: this.PLPrice,
        name: this.name,
        phone: this.phone,
        email: this.email,
      }).then((response) => {
        if (response.error) {
          this.error = response.error;
          this.errors = response.errors ? response.errors : [];
        }

        if (response.status) {
          this.success = response.success;
          this.errors = [];
        }

        this.loadingSend = false;
      });
    },
  },
};
</script>

<style scoped>
/* Центр по вертикали в свободном месте main
   (main — flex-колонка, см. style.css) */
.catalog-public__container {
  margin: auto;
  width: 100%;
}

.application-heading {
  margin: 0 auto;
  text-align: center;
}

.application-heading .hr {
  margin-top: 22px;
}

.application-heading h3 {
  margin: 0 0 27px;
  color: #004680;
  font-size: 24px;
}

</style>
